<template>
  <el-table-column
    prop="vat_value"
    sortable="custom"
    label="ÁFA összeg"
    show-overflow-tooltip
    min-width="130"
  >
    <template slot-scope="scope">
      <div v-if="scope.row.vat_value">
        {{ scope.row.vat_value | currency(scope.row.currency_code) }}
      </div>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'vat_value',
};
</script>
